import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c5fa5fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "set-zipcode__header" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "invalid-feedback" }
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["set-zipcode mb-xs-2", {'was-validated': _ctx.invalidZip}])
  }, [
    _createElementVNode("h4", _hoisted_1, _toDisplayString(_ctx.$t("ZipCode.Header")), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", null, [
        _createTextVNode(_toDisplayString(_ctx.$t("ZipCode.Label")) + " ", 1),
        _createElementVNode("input", {
          name: "zipcode",
          ref: "zip",
          type: "text",
          onInput: _cache[0] || (_cache[0] = event => _ctx.validateZip(false)),
          onChange: _cache[1] || (_cache[1] = event => _ctx.validateZip(true)),
          onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.onEnterKey($event, _ctx.zipCode)), ["enter"])),
          inputmode: "numeric",
          pattern: "^(LV-\\d{4}|[0-9]{3}\\s?[0-9]{2})$",
          disabled: _ctx.disabled
        }, null, 40, _hoisted_3),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("ZipCode.InvalidZip")), 1)
      ]),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = event => _ctx.validateZip(true) && _ctx.onSubmit(_ctx.zipCode)),
        disabled: _ctx.zipCode === '' || _ctx.disabled,
        type: "button",
        class: "button--primary button--base"
      }, _toDisplayString(_ctx.$t("ZipCode.Confirm")), 9, _hoisted_5)
    ])
  ], 2))
}